import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex xl:flex-row flex-col xl:h-screen bg-secondary overflow-y-visible no-scrollbar" }
const _hoisted_2 = { class: "relative flex-1 flex flex-col" }
const _hoisted_3 = { class: "flex-1 xl:overflow-y-auto no-scrollbar mb-16 xl:mb-0" }
const _hoisted_4 = { class: "fixed bottom-0 left-0 w-full" }

import { onMounted, ref } from "vue";
import SidebarMenu from "@/components/SidebarMenu.vue";
import AbsolutePageHeader from "@/components/headers/AbsolutePageHeader.vue";
import TagSidebarItems from "@/components/sidebar/TagSidebarItems.vue";
import BlogSearch from "@/views/Blogs/components/BlogSearch.vue";
import BlogGrid from "@/views/Blogs/components/BlogGrid.vue";
import { blogPage } from "@/constants/breadcrumbs";
import { useBlogsStore } from "@/stores/blogsStore";
import ShowMoreButton from "@/views/Blogs/components/ShowMoreButton.vue";
import { useBlogTagsStore } from "@/stores/blogTagsStore";
import PageFooter from "@/components/PageFooter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogsView',
  setup(__props) {

const blogsCardsStore = useBlogsStore();
const tagsStore = useBlogTagsStore();

const isMenuOpen = ref(false);

onMounted(() => {
  if (blogsCardsStore.blogList.length === 0) {
    blogsCardsStore.fetchBlogsCards();
  }
});

function loadMoreBlogs() {
  if (!blogsCardsStore.hasNextPage) {
    return;
  }
  blogsCardsStore.loadNextPage();
}

function searchBlog(search: string) {
  if (!search) {
    blogsCardsStore.fetchBlogsCards();
  } else {
    blogsCardsStore.searchBlogs(search);
  }
  tagsStore.resetSelectedTag();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarMenu, {
      "show-blog-btn": false,
      "is-menu-open": isMenuOpen.value,
      onToggleMenu: _cache[1] || (_cache[1] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value)),
      class: "sticky top-0"
    }, {
      default: _withCtx(() => [
        _createVNode(TagSidebarItems, {
          onCloseMenu: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = false))
        })
      ]),
      _: 1
    }, 8, ["is-menu-open"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(AbsolutePageHeader, {
        "show-blog-btn": false,
        breadcrumbs: _unref(blogPage)
      }, null, 8, ["breadcrumbs"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BlogSearch, { onSearch: searchBlog }),
        _createVNode(BlogGrid, {
          "blog-list": _unref(blogsCardsStore).blogList
        }, null, 8, ["blog-list"]),
        (_unref(blogsCardsStore).hasNextPage)
          ? (_openBlock(), _createBlock(ShowMoreButton, {
              key: 0,
              onLoadMoreBlogs: loadMoreBlogs,
              "is-api-loading": _unref(blogsCardsStore).isListLoading
            }, null, 8, ["is-api-loading"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(PageFooter)
      ])
    ])
  ]))
}
}

})